<script>
    import appConfig from "../../../app.config";
    import "swiper/swiper-bundle.css";
    import axios from 'axios';
    // import animationData from "@/components/widgets/lupuorrc.json";
    // import Lottie from "@/components/widgets/lottie.vue";
    import Swal from 'sweetalert2';



    // this.$route.params.hash
    export default {
        page: {
            title: "Starter",
            meta: [{
                name: "description",
                content: appConfig.description
            }],
        },
        data() {
            return {
                title: "Starter",
                items: [{
                        text: "Pages",
                        href: "/",
                    },
                    {
                        text: "Starter",
                        active: true,
                    },
                ],
                
                listBank:[],
                bank:'',
                firstName:'',
                IsSessionOk:'1',

                CreaditCheck: '',
            };
        },

       
        methods: {

            sessionCheck(UserId){
                
                axios.get(process.env.VUE_APP_API_BASEURL+'session/'+UserId)
                .then(response => {
                    if (response) {
                        this.IsSessionOk=response.data;
                    }
                })
            },

            /*creditchck(UserId){
                
                axios.get(process.env.VUE_APP_API_BASEURL+'creditchck/'+UserId)
                .then(response => {
                    if (response) {
                        this.CreaditCheck=response.data;

                        if(this.CreaditCheck.credit_check == 2||this.CreaditCheck.credit_check == 3){
                            this.FailCreditCheck(UserId);
                        }else if(this.CreaditCheck.credit_check == 0){

                            if(this.CreaditCheck.draf == 1){
                                
                                
                                Swal.fire({
                                    title: 'Credit Check Still In Progress !',
                                    text:   "Please Wait",
                                    icon: 'error',
                                }).then((result) => {
                                    if (result.value) {
                                        this.creditchck(this.customerId);
                                    }
                                });

                                setTimeout(()=>this.creditchck(this.customerId),30000);
                                // this.FailCreditCheck(UserId);
                            }else{
                                window.location.href=process.env.VUE_APP_URL+'customer/create/'+this.$route.params.id+'/'+this.$route.params.hash;
                            }
                            
                        }else{
                            Swal.fire({
                                title: 'Credit Check Pass',
                                icon:  'success',
                            });
                        }
                    }
                })
            },

            FailCreditCheck(UserId){
                axios.get(process.env.VUE_APP_API_BASEURL+'creditchck/FailCreditCheck/'+UserId)
                .then(response => {
                    if (response) {
                        Swal.fire({
                            title: 'Credit Check Fail !',
                            text:   "We’re sorry! Unfortunately, your application for the ReNew+ Subscription Program is unsuccessful. We recommend that you explore other payment options available on Switch online store. Thank you.",
                            icon: 'error',
                        
                        }).then((result) => {
                            if (result.value) {
                                if(typeof response.data.url !== 'undefined'){
                                    window.location.href = response.data.url;
                                }
                      
                            }
                        });
                    }
                })
            },*/
            
            getDetail(){
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/create/'+this.$route.params.id+'/'+this.$route.params.hash)
                .then(response => {
                    if (response) {
                        if(response.data.status=='error'){
                            this.messageBag = response.data.msj;
                        }else{
                            this.detail = response.data;
                            console.log("Detail VAL",this.detail);
                            this.detailSeen  = true;
                            // if (this.detail.last_name !== null){
                            //     this.email_name = this.detail.first_name + ' ' + this.detail.last_name;
                            // }else{
                            //     this.email_name = this.detail.first_name;
                            // }
                            
                            this.firstName =this.detail.name_as_per_nric;

                            this.lastName = this.detail.last_name;
                            this.emailAddress = this.detail.email;
                            this.phoneNumber = this.detail.phone_number;
                            this.nric = this.detail.nric;
                            this.address = this.detail.address;
                            this.addressmix = this.detail.address+', '+this.detail.postalcode+', '+this.detail.city;
                            this.postalCode = this.detail.postalcode;
                            this.city = this.detail.city;
                            this.state = this.detail.state_id;
                            this.country = this.detail.country_id;

                            this.dateOfBirth = this.detail.dob;
                            this.gender = this.detail.gender;
                            this.tenure = this.detail.tenure;
                            this.phone_model = this.detail.phone_model;
                            this.store_name = this.detail.store_name;
                            this.race_cus = this.detail.race_cusbaru;
                            this.sku = this.detail.sku;
                            this.aplicationsource = this.detail.applicationsource;
                            
                            
                        }
                        
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },
            async getBank(){
                await axios.get(process.env.VUE_APP_API_NODEJS+'/bankList')
                .then(response => {
                    console.log("BANK", response.data)
                    if (response) {
                        this.listBank=response.data;
                                                
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            getCustomer(){
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/getdetail/'+this.$route.params.id)
                .then(response => {
                    this.temporayaddress='';
                    this.postalCodetemp='';
                    this.citytemp='';
                    this.statetemp='';
                    this.countrytemp='';
                    this.OrderId = '';

                    if (typeof response.data.customer.id !== 'undefined') {

                        if(response.data.customer.draf == null||response.data.customer.draf == '0'){
                            window.location.href=process.env.VUE_APP_URL+'customer/create/'+this.$route.params.id+'/'+this.$route.params.hash;
                        }
                        this.temporayaddress=response.data.customer.temporary_address;
                        this.postalCodetemp=response.data.customer.temporary_postalcode;
                        this.citytemp=response.data.customer.temporary_city;
                        this.statetemp=response.data.customer.temporary_state;
                        this.countrytemp=response.data.customer.temporary_country_id;
                        this.temporaryAddressDisable=true;
                        this.customerId = response.data.customer.id;
                        this.sessionCheck(this.customerId);
                        //this.creditchck(this.customerId);
                        
                        // console.log(response.data.order);
                        // console.log('****-----****');
                        this.companyname =response.data.customer.employment_company_name;
                        this.general_line = response.data.customer.employment_office_gneral_line;

                        if (typeof response.data.order.id !== 'undefined') {
                            this.OrderId = response.data.order.id;

                            if(response.data.order.front_nric !=null ||response.data.order.front_nric ==''){
                                this.disableTOFinance = false;
                                // console.log('-------------**********');
                                console.log(response.data.order.front_nric);
                            }
                        }
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            getProductDetails(){                
                axios.get(process.env.VUE_APP_API_BASEURL+'program_device/info/'+this.$route.params.id)
                .then(response => {
                    if (response) {
                        this.productDetailsList=response.data;
                        this.product_name = this.productDetailsList[0].product_name
                        this.color_name = this.productDetailsList[0].color_name
                        this.capacity_name = this.productDetailsList[0].capacity_name
                        this.tenure = this.productDetailsList[0].tenure
                        this.price = this.productDetailsList[0].price
                        this.program_fee = this.productDetailsList[0].program_fee
                        //this.total_upfront = this.price + this.program_fee
                    } 
                    else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderSeen = false;
                });
            },


            tocurlect(){
                if(this.firstName == ''){
                    alert("Please Enter Name")
                }else{
                    const posting_ = { 
                            temporayaddress: this.temporayaddress,
                            postalCodetemp:this.postalCodetemp, 
                            citytemp:this.citytemp, 
                            statetemp:this.statetemp, 
                            countrytemp:this.countrytemp, 
                            namenric:this.firstName,
                            applicationsource:this.aplicationsource,
                            race_cus:this.race_cus,
                        };
                        axios.post(process.env.VUE_APP_API_BASEURL+'customer/step1/'+this.$route.params.id, posting_)
                        .then(response => {
                            if (response) {
                                // console.log(response.data);
                                if(response.data.status == 'successfully'){
                                    console.log("Success");
                                }else{
                                    alert('fail to save data');
                                }
                            } else {
                                this.messageBag = ['No record.'];
                                this.abletoSendRequestVerify = true;
                            }
                            this.loadRequestCode=false;
                        })
                            .catch(error => {
                                this.messageBag = [error.error];
                        });
                
                if (this.bank){
                    const grandTotal = this.price+this.program_fee;
                    const Todaydate = new Date().toJSON().slice(0, 10);
                    var dataTocurlec = JSON.stringify({
                        "customerId": this.customerId,
                        "typeofIdentity": "NRIC",
                        "amount": grandTotal,
                        "effectiveDate": Todaydate,
                        "bankId": this.bank.toString().replace(/['"]+/g, '')

                        // "customerId": 1172,
                        // "typeofIdentity": "NRIC",
                        // "amount": 243.63,
                        // "effectiveDate": "2023-03-20",
                        // "bankId": "19"
                        
                    });

                    console.log(dataTocurlec);

                    var hasingVar = this.$route.params.hash;
                    var idVar = this.OrderId;

                    var config = {
                        method: 'post',
                        //url: process.env.VUE_APP_API_NODEJS+'/generatePaymentLink',
                        url: process.env.VUE_APP_API_NODEJS+'/v2/generateMandateLink',
                        headers: { 
                            'Content-Type': 'application/json'
                        },
                        data : dataTocurlec
                    };

                        axios(config)
                        .then(function (response) {
                            if (typeof response.data.url !== 'undefined') {
                                window.location.href = response.data.url;
                            }else{
                                if (typeof response.data.message !== 'undefined') {
                                    alert(response.data.message);
                                }
                            }
                            // console.log(JSON.stringify(response.data));

                        }).catch(function (error) {
                             if (error.response) {
                                Swal.fire({
                                    title: error.response.data.message,
                                    icon: "warning",
                                    confirmButtonColor: "#f46a6a",
                                }).then((result) => {
                                    if (result.value) {
                                        axios.get(process.env.VUE_APP_API_BASEURL+'session/timeout/sent/'+idVar+'/'+hasingVar+'/'+error.response.data.message)
                                        .then(response => {
                                            if (response) {
                                                if (typeof response.data.url !== 'undefined') {
                                                    window.location.href=response.data.url;
                                                }
                                            } else {
                                                this.messageBag = ['No record.'];
                                                this.OrderSeen = false;
                                            }
                                        })
                                            .catch(error => {
                                                this.messageBag = [error.error];
                                                this.OrderSeen = false;
                                        });
                                    }
                                });
                            }
                            console.log(error);
                        });
                }else{
                    alert("Please select bank")
                }
                
               
                }
               
            },
           
        },
        watch: {

            timerCount: {
                handler(value) {

                    if (value > 0) {
                        setTimeout(() => {
                            this.timerCount--;
                        }, 8*100);
                    }

                },
                immediate: true // This ensures the watcher is triggered upon creation
            }
        },  

        
        components: {
            // lottie: Lottie

        },
        mounted(){
            window.location.href=process.env.VUE_APP_RENEWNGO_WEBCLIENT_HOST + '/applications/order-confirmation?temporary_id=' + this.$route.params.id + '&hash=' + this.$route.params.hash;
        //     this.getCustomer();
        //     this.getProductDetails();
        //     this.getBank();
        //     this.getDetail();
            
            window.location.href=process.env.VUE_APP_RENEWNGO_WEBCLIENT_HOST + '/applications/order-confirmation?temporary_id=' + this.$route.params.id + '&hash=' + this.$route.params.hash;
        //     this.getCustomer();
        //     this.getProductDetails();
        //     this.getBank();
        //     this.getDetail();
        // console.log("Helllooo");
        }
    };
</script>
<style >
    #container{
    padding-top:20px;
    margin-top:20px;
    width:100vw;
    color:white;
    background-color:#003E30;
    display:flex;
    flex-direction:column;
    align-items:center;
    position:fixed;
    bottom:0;
    }
    #contacts{
    display:flex;
    justify-content:space-around;
    align-items:center;
    width:100%;
    }
    #contacts--contact{
    text-align:right;
    }
    #contacts--social{
    width:20%;
    display : flex;
    justify-content : space-between;
    }
    #contacts--social div{
    height:30px;
    width:30px;
    background-color:white;
    border-radius:50%;
    }
    #mentions p {
    font-size:0.5em;
    }
    .card {
    margin-bottom: -9.5rem !important;
    }
    .avatar-title {
        background-color: #695eef00 !important;
        padding: 180px;
        cursor: pointer;
    }
    .dt-show{
        display: block;
    }
    .mb-show{
        display: none;
    }
    @media (min-width: 320px) and (max-width: 500px){
        .col-9 {
            width: 100%;
        }
        .progress-nav .progress {
                position: absolute;
                /* left: -661.8%;
                top: 49%;
                width: 1329%;
                transform: rotate(90deg); */
           }

        .dt-show{
        display: none;
        }
        .mb-show{
        display: block;
        }
        .mt-mbr{
            margin-top: 3rem;
        }
        td {
            word-wrap: break-word !important;
           }
       }
    @media (min-width: 2001px) and (max-width: 2500px){
           
           .progress-nav .progress {
               position: absolute;
               transform: rotate(90deg);
               left: -14.7rem;
           }
           /* .progress-nav {
               padding-left: 13rem;
           } */
       }
 
    @media (min-width: 1920px) and (max-width: 2000px){
           
        .progress-nav .progress {
            position: absolute;
            transform: rotate(90deg);
            padding-left: 26rem;
            
        }
        .progress-nav {
            padding-left: 13rem;
        }
    }

    @media (min-width: 1280px) and (max-width: 1919px){
           
           .progress-nav .progress {
            position: absolute;
            left: -112.8%;
            top: 49%;
            width: 226%;
            transform: rotate(90deg);
           }
       }
        

    .tabinfo{
        font-size: 16px;
        white-space: nowrap;
        margin-top: 5px;
        padding-left: 5px;
    }
    .fixed-top {
        background-color: #F3F4F6 !important;
    }
    .navbar {
    padding-top: 0px !important;
    /* padding-bottom: 0px !important; */
    }
    .container-fluid{
    padding-right: 0px !important;
    padding-left: 0px !important;
    }
    .progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
    background-color: #77BF4C !important;
    }
    .progress-bar {
        background-color: #77BF4C !important;
    }
    .progress {
    background-color: #77bf4c !important;
    }
    .pt-tab {
    padding-top: 7rem;
    }
    .btn-primary:hover {
        color: #fff;
        background-color: #77BF4C;
        border-color: #77BF4C;
    }
    .btn {
        color: #fff;
        background-color: #77BF4C !important;
        border-color: #77BF4C !important;
    }
    .form-check-input:checked {
        background-color: #77bf4c !important;
        border-color: #77bf4c !important;
    }
    .border-top {
    border-top: 1px solid #fff !important;
}
</style>


<template>

    <div class="layout-wrapper landing">

        <nav class="navbar navbar-expand-lg fixed-top" id="navbar">
            <div class="container">
                <a class="navbar-brand" href="index.html">
                    <img style="width: 95px" src="https://renewp.compasia.com/assets/images/logo.png" class="img-fluid card-logo card-logo-dark" alt="logo dark" >
                    <img src="https://renewp.compasia.com/assets/images/logo.png" class="card-logo card-logo-light" alt="logo light" >
                </a>
            </div>
        </nav>

        <section class="section pb-0 hero-section" id="hero">
        <!-- start hero section -->
            <!-- <div class="bg-overlay bg-overlay-pattern"></div> -->
            <div id="custom-progress-bar" class="progress-nav mb-show" style="margin-bottom: -77px;padding-top: 85px;">
                <div class="progress" style="height: 1px;top: 103px;">
                    <div class="progress-bar progress-bar-striped" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <ul class="nav nav-pills progress-bar-tab custom-nav" role="tablist">
                    <li class="nav-item" role="presentation">
                            <button style="pointer-events: none;" class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-gen-info-tab" data-bs-toggle="pill" data-bs-target="#pills-gen-info" type="button" role="tab" aria-controls="pills-gen-info" aria-selected="true">1</button>
                    </li>
                    
                    <li class="nav-item" role="presentation">
                            <button style="pointer-events: none;" :disabled='disableUpload' class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-info-desc-tab" data-bs-toggle="pill" data-bs-target="#pills-info-desc" type="button" role="tab" aria-controls="pills-info-desc" aria-selected="false">2</button>
                    </li>
                    <li class="nav-item" role="presentation">
                            <button style="pointer-events: none;" :disabled="disableTOFinance" class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-info-warning-tab" data-bs-toggle="pill" data-bs-target="#pills-warning-desc" type="button" role="tab" aria-controls="pills-warning-desc" aria-selected="false">3</button>
                    </li>
                    <li class="nav-item" role="presentation">
                            <button style="pointer-events: none;" class="nav-link rounded-pill" data-progressbar="custom-progress-bar active" id="pills-success-tab" data-bs-toggle="pill" data-bs-target="#pills-success" type="button" role="tab" aria-controls="pills-success" aria-selected="false">4</button>
                    </li>
                </ul>
            </div>
        <div class="row" style="background-color: white;">
            <div class="col-3 pt-5 p-5">
                                    
                <div id="custom-progress-bar" class="progress-nav dt-show">
                    <div class="progress" style="height: 1px;">
                        <div class="progress-bar progress-bar-striped" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <!--    class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical" -->
                    <ul class="nav nav-pills progress-bar-tab custom-nav d-flex flex-column" role="tablist">
                        <li class="nav-item d-flex" role="presentation">
                        
                                <button style="pointer-events: none;" class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-gen-info-tab" data-bs-toggle="pill" data-bs-target="#pills-gen-info" type="button" role="tab" aria-controls="pills-gen-info" aria-selected="true">1</button>
                                <span class="tabinfo">Personal Information</span>
                            
                        </li>
                        
                        <li class="nav-item pt-tab d-flex" role="presentation">
                        
                                <button style="pointer-events: none;" :disabled='disableUpload' class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-info-desc-tab" data-bs-toggle="pill" data-bs-target="#pills-info-desc" type="button" role="tab" aria-controls="pills-info-desc" aria-selected="false">2</button>
                                <span class="tabinfo">References Information</span>
                        
                        </li>
                        <li class="nav-item pt-tab d-flex" role="presentation">
                        
                                <button style="pointer-events: none;" :disabled="disableTOFinance" class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-info-warning-tab" data-bs-toggle="pill" data-bs-target="#pills-warning-desc" type="button" role="tab" aria-controls="pills-warning-desc" aria-selected="false">3</button>
                                <span class="tabinfo">Employment Information</span>
                        
                        </li>
                        <li class="nav-item pt-tab d-flex" role="presentation">
                            
                            
                                <button style="pointer-events: none;" class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-success-tab" data-bs-toggle="pill" data-bs-target="#pills-success" type="button" role="tab" aria-controls="pills-success" aria-selected="false">4</button>
                                <span class="tabinfo">Confirm Order</span>
                    
                        </li>
                    </ul>
                </div>
            </div>
            
            <div class="col-9 pb-5">
                <div class="container-fluid">
                    <div class="p-3">
                        <div class="text-right mt-5">
                            <h5>Your Online Banking Monthly Payment Preference</h5>
                            <div>
                                <div>
                                        <label for="basiInput" class="form-label">Name as per NRIC<span style="color: red;">*</span></label>
                                        <input type="text" class="form-control" v-on:keypress="NameValidation" v-model="firstName">
                                        <span style="color: #b7afaf;">
                                            e.g. Amir Radzi Bin Muhammad Shamim
                                        </span> 
                                </div>
                                <label for="placeholderInput" class="form-label">Bank</label>
                                <select @change="onChange($event)" v-model="bank" class="form-select mb-3" arial-label="Default select example" required>
                                    <option value="">Please Select Bank</option>
                                    <option v-for="(item, index) in listBank" :key="index" :value="item.id">
                                        {{ item.name.toString().replace(/['"]+/g, '') }}
                                    </option>
                            
                                </select>
                            </div>
                            <div class="d-flex align-items-start gap-3 mt-4">
                                <!-- <button @click="$router.push('/customer/create/auth')" class="btn btn-success btn-label right ms-auto nexttab nexttab" data-nexttab="pills-auth-desc-tab" >
                                    <i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Confirm
                                </button> -->
                                <button type="button" class="btn btn-success btn-label right ms-auto nexttab nexttab" @click='tocurlect' data-nexttab="pills-auth-desc-tab" >
                                    <i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Confirm
                                </button>
                            </div>

                        </div>
                    </div>
                    
                    <div class="text-center mt-lg-5 pt-5">
                        <div class="d-flex gap-2 justify-content-center mt-4">
                            <!-- <a href="auth-signup-basic.html" class="btn btn-primary">Submit <i class="ri-arrow-right-line align-middle ms-1"></i></a> -->
                        </div>
                    </div>
                    <!-- end row -->
                </div>
            </div>
        </div>
   
        <div id="container">
            <div id="contacts">
                <div id="contacts--contact">
                    <div>{{ new Date().getFullYear()  }} &copy; CompAsia</div>
                </div>
                <div >
                    <div></div>
                    <div></div>
                    <div>Design & Develop by Compasia IT</div>
                </div>
            </div>
            <div id="mentions">
                <p></p>
            </div>
        </div>
    </section>
</div>
    
</template>